import { gql, useApolloClient, useMutation, } from '@apollo/client';
import { ARCHIVE_FIELDS } from '@isyc-react/oc-api';
//////////////////////////////////////////////////
const ARCHIVE_CREATE_MULTIPLE_INTERNAL = gql `
  ${ARCHIVE_FIELDS}
  mutation archiveCreateMultipleInternal(
    $archiveCreateFrontAndBackInternal: ArchiveFormDtoMultipleInternalInput
    $businessUnitId: Long
  ) {
    archive_createMultipleInternal(
      archiveCreateFrontAndBackInternal: $archiveCreateFrontAndBackInternal
      businessUnitId: $businessUnitId
    ) {
      ...ArchiveFields
    }
  }
`;
export const useArchiveCreateMultipleInternalMutation = (options) => useMutation(ARCHIVE_CREATE_MULTIPLE_INTERNAL, options);
export const useArchiveCreateMultipleInternalMutationPromise = () => {
    const client = useApolloClient();
    return (variables, options) => client.mutate(Object.assign(Object.assign({}, options), { mutation: ARCHIVE_CREATE_MULTIPLE_INTERNAL, variables }));
};
